<template>
  <v-container>
    <div
      style="max-width: 500px; margin: 0 auto;"
    >
      <div
       v-show="dialog === 'login' && providerLoginEnabled"
      >
        <v-row dense>
          <v-col style="text-align: center;">{{ translate('ui_login_with') }}</v-col>
        </v-row>

        <v-row dense>
          <v-col style="display: flex; justify-content: center; align-items: center;">

            <v-btn href="/api/user/auth/facebook"
              style="background: #4267b2; color: #fff;"
            >
              <v-icon style="margin-right: 10px;">
                mdi-facebook
              </v-icon>&nbsp;&nbsp;Facebook
            </v-btn>

            <v-btn href="/api/user/auth/google"
              style="margin-left: 20px; padding: 0; background: #fff;
              border: 1px solid #3c82f7;
              "
            >
              <img style="height: 18px; margin-top: -2px; padding: 0 11px;"
              src="../assets/icon-google.webp" alt="GOOGLE">

              <div style="
              border-top-right-radius: 4px; border-bottom-right-radius: 4px;
              color: #fff;  background-color: #3c82f7; height: 100%; padding: 10px 20px;">
                Google
              </div>
            </v-btn>

          </v-col>

          <v-col style="margin-top:10px; display: flex;
          justify-content: center; align-items: center;">
            <div style="border-top: 1px solid #ddd; width: 100px;
            margin-right: 20px; height: 1px;"></div>
            <div><strong>{{ translate('ui_login_or') }}</strong></div>
            <div style="border-top: 1px solid #ddd; width: 100px;
            margin-left: 20px; height: 1px;"></div>
          </v-col>
        </v-row>
      </div>

      <div>
        <v-row dense v-show="dialog !== 'updatePassword'">
          <v-col>
            <v-text-field
              label="Email"
              ref="emailInput"
              type="email"
              name="email"
              clearable
              autocomplete
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense v-show="dialog !== 'forgotPassword'">
          <v-col>
            <v-text-field
              :label="translate('ui_login_input_password')"
              type="password"
              name="password"
              ref="passwordInput"
              clearable
              autocomplete
            ></v-text-field>
          </v-col>
        </v-row>
      </div>

      <div v-show="dialog === 'login'">
        <v-row dense>
          <v-col style="display: flex; justify-content: space-between;">

            <v-btn @click="login" color="cyan darken-1" style="color: #fff;">
              {{ translate('ui_login') }}
            </v-btn>

            <v-btn text @click="showRequestResetPasswordDialog" color="cyan darken-1"
            style="color: #fff;"
            >
              {{ translate('ui_login_forgot_password') }}
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col style="text-align: center;">
            {{ translate('ui_login_dont_have_account') }}
            <v-btn
              @click="dialog = 'register'"
              text
              style="margin-left: 20px; text-decoration: underline;"
            >
              {{ translate('ui_login_signup') }}
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-row v-show="dialog === 'forgotPassword'">
        <v-col style="text-align: center;">
          <v-btn @click="requestResetPassword" color="cyan darken-1" style="color: #fff;">
            {{ translate('ui_login_password_reset') }}
          </v-btn>
          <v-col style="text-align: center; margin-top: 20px;">
            {{ translate('ui_login_have_account') }}
            <v-btn
              @click="dialog = 'login'"
              text
              style="margin-left: 20px; text-decoration: underline;"
            >
              {{ translate('ui_login') }}
            </v-btn>
          </v-col>
        </v-col>
      </v-row>


      <v-row>
        <v-col style="text-align: center;">
          <v-btn  v-show="dialog === 'register'" @click="register"
          color="cyan darken-1" style="color: #fff;">
            {{ translate('ui_login_register') }}
          </v-btn>

          <v-btn v-show="dialog === 'updatePassword'" @click="updatePassword"
          color="cyan darken-1" style="color: #fff;"
          >
            {{ translate('ui_login_update_password') }}
          </v-btn>

        </v-col>
      </v-row>

      <v-row>
        <v-col v-show="dialog !== 'login'" style="text-align: center;">
          {{ translate('ui_login_have_account') }}
          <v-btn
            @click="showLoginDialog"
            text
            style="margin-left: 20px; text-decoration: underline;"
          >
            {{ translate('ui_login_signin') }}
          </v-btn>
        </v-col>

      </v-row>

      <v-row>
        <v-col style="text-align: center;">
          <router-link to="templates" style="text-decoration: none;">
            <v-btn outlined color="red darken-1"
            >
              {{ translate('ui_login_skip') }}
            </v-btn>
          </router-link>
        </v-col>
      </v-row>

    </div>


    <v-dialog
      v-model="requestResetPasswordDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title>
          {{ translate('ui_login_password_reset') }}
        </v-card-title>

        <div v-if="$store.state.dialogs.requestResetPassword === 'input'">
          <v-card-text>
            <v-text-field
              :label="translate('ui_login_emailed_used_to_register')"
              ref="emailInput"
              type="email"
              name="email"
              autocomplete
              clearable
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="requestResetPassword"
            >
              {{ translate('ui_login_request_reset') }}
            </v-btn>
          </v-card-actions>
        </div>

        <v-card-text v-if="$store.state.dialogs.requestResetPassword === 'pending'"
        style="display: flex; justify-content: center;">
          <v-progress-circular
            color="red"
            :size="40"
            :width="3"
            indeterminate
          ></v-progress-circular>
        </v-card-text>

        <v-card-text v-if="$store.state.dialogs.requestResetPassword === 'success'">
          {{ translate('ui_login_request_reset_confirmation') }}
        </v-card-text>

        <v-card-text v-if="$store.state.dialogs.requestResetPassword === 'loggedin'">
          <div>
            {{ translate('ui_login_already_loggedin') }}
          </div>
          <div>
            {{ translate('ui_login_go_to_templates') }}
            <router-link to="/templates">
              {{ translate('ui_left_menu__templates') }}
            </router-link>
          </div>
        </v-card-text>

        <v-card-text v-if="$store.state.dialogs.requestResetPassword === 'nouser'">
          {{ translate('ui_login_no_user') }}
          <a @click="showRegisterDialog">
            {{ translate('ui_login_register') }}
          </a>
        </v-card-text>

        <v-card-actions
          v-if="showrequestResetPasswordDialogCloseButton"
        >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="requestResetPasswordDialogVisible = false"
          >
            {{ translate('ui_close_btn') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="passwordUpdatedDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title>
          {{ translate('ui_login_update_password') }}
        </v-card-title>

        <v-card-text  v-if="$store.state.dialogs.passwordUpdated === 'pending'"
        style="display: flex; justify-content: center;">
          <v-progress-circular
            color="red"
            :size="40"
            :width="3"
            indeterminate
          ></v-progress-circular>
        </v-card-text>

        <v-card-text v-if="$store.state.dialogs.passwordUpdated === 'success'">
          {{ translate('ui_login_password_updated') }}
           <a @click="showLoginDialog">
            {{ translate('ui_login_signin') }}
          </a>
        </v-card-text>
        <v-card-text v-if="$store.state.dialogs.passwordUpdated === 'tokenexpired'">
          {{ translate('ui_login_token_expired') }}
           <a @click="showRequestResetPasswordDialog">
            {{ translate('ui_login_password_reset') }}
          </a>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="passwordUpdatedDialogVisible = false"
          >
            {{ translate('ui_close_btn') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loginResultDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title class="">
          {{ translate('ui_login_alert') }}
        </v-card-title>

        <v-card-text v-if="$store.state.dialogs.loginResult === 'userExists'">
          {{ translate('ui_login_user_exists') }}
        </v-card-text>
        <v-card-text v-if="$store.state.dialogs.loginResult === 'wrongUserOrPassword'">
          <p>{{ translate('ui_login_wrong_login') }}</p>
        </v-card-text>

        <v-card-actions>

          <router-link to="feedback" style="text-decoration: none;">
            <v-btn outlined color="red darken-1"
            >
              {{ translate('ui_login_need_help') }}
            </v-btn>
          </router-link>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            @click="loginResultDialogVisible = false"
          >
            {{ translate('ui_close_btn') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
// mixins
import Mixin from '../mixins/mixin';

export default {
  name: 'Login',
  mixins: [Mixin],
  props: {
    updatePasswordNow: Boolean,
  },
  data: () => ({
    dialog: 'login',
    requestResetPasswordDialogVisible: false,
    passwordUpdatedDialogVisible: false,
    providerLoginEnabled: true,
  }),
  computed: {
    showrequestResetPasswordDialogCloseButton() {
      return this.$store.state.dialogs.requestResetPassword !== 'input'
      && this.$store.state.dialogs.requestResetPassword !== 'pending';
    },
    loginResultDialogVisible: {
      get() {
        return this.$store.state.dialogs.loginResultDialogVisible;
      },
      set(value) {
        this.$store.commit('updateState', {
          path: 'dialogs.loginResultDialogVisible',
          value,
        });
      },
    },
  },
  methods: {
    showRegisterDialog() {
      this.dialog = 'register';
      this.requestResetPasswordDialogVisible = false;
    },
    showRequestResetPasswordDialog() {
      this.$store.commit('updateState', {
        path: 'dialogs.requestResetPassword',
        value: 'input',
      });
      // in case was it was open from the update password dialog
      this.passwordUpdatedDialogVisible = false;

      this.requestResetPasswordDialogVisible = true;
    },
    showLoginDialog() {
      if (this.dialog === 'updatePassword') {
        this.dialog = 'login';
        this.$router.push('/');
        this.passwordUpdatedDialogVisible = false;
      } else {
        this.dialog = 'login';
      }
    },
    login() {
      const email = this.$refs.emailInput.$refs.input.value;
      const password = this.$refs.passwordInput.$refs.input.value;
      this.$store.dispatch('login', {
        email,
        password,
      });
    },
    register() {
      const email = this.$refs.emailInput.$refs.input.value;
      const password = this.$refs.passwordInput.$refs.input.value;
      this.$store.dispatch('register', {
        email,
        password,
      });
    },
    loginFacebook() {
      this.$store.dispatch('login', {
        service: 'facebook',
      });
    },
    loginGoogle() {
      this.$store.dispatch('login', {
        service: 'google',
      });
    },
    requestResetPassword() {
      const email = this.$refs.emailInput.$refs.input.value;
      this.$store.dispatch('requestResetPassword', {
        email,
      });
    },
    updatePassword() {
      const token = window.location.href.split('?token=')[1];
      const password = this.$refs.passwordInput.$refs.input.value;
      const data = {
        token,
        password,
      };
      this.$store.dispatch('updatePassword', data);
      this.passwordUpdatedDialogVisible = true;
    },
  },
  mounted() {
    if (this.updatePasswordNow) {
      this.dialog = 'updatePassword';
      // update page title
      this.$store.commit('updatePageTitle', 'ui_login_update_password');
    }
  },
};
</script>
